// Single source of truth for legal-document version identifiers.
// These MUST match the version/date shown in each document's footer, and are
// stored against every reservation as the version the buyer accepted.
// Bump the version + date here (and in the matching legal HTML/page footer)
// whenever a document is revised.
export const LEGAL_VERSIONS = {
  privacy: { version: "1.0", date: { en: "25 June 2026", sr: "25. jun 2026." } },
  terms: { version: "1.0", date: { en: "25 June 2026", sr: "25. jun 2026." } },
};
